import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getUserLanguage } from '../../utils/language';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  // Use the updated language utility that checks domain
  const language = getUserLanguage();

  const texts = {
    cs: {
      message: 'Tato stránka používá cookies k zajištění nejlepšího zážitku. Používáním stránek souhlasíte s našimi podmínkami, zásadami ochrany osobních údajů a používáním cookies.',
      accept: 'Přijmout',
      decline: 'Odmítnout',
      settings: 'Nastavení',
      save: 'Uložit',
      terms: 'Podmínky užití',
      privacy: 'Zásady ochrany osobních údajů',
      cookies: 'Nastavení cookies',
    },
    en: {
      message: 'This website uses cookies to ensure the best experience. By using the site, you agree to our terms, privacy policy, and cookie usage.',
      accept: 'Accept',
      decline: 'Decline',
      settings: 'Settings',
      save: 'Save',
      terms: 'Terms and Conditions',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Settings',
    },
  };

  const currentText = texts[language] || texts.en; // Fallback to English

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-50 shadow-lg">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm">{currentText.message}</p>
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            onClick={handleAccept}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded transition-colors"
          >
            {currentText.accept}
          </button>
          <button
            onClick={handleDecline}
            className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded transition-colors"
          >
            {currentText.decline}
          </button>
          <Link
            to="/cookies"
            className="text-gray-400 hover:text-red-500 text-sm transition-colors underline"
          >
            {currentText.settings}
          </Link>
        </div>
      </div>
      <div className="text-center mt-2">
        <Link to="/terms" className="text-gray-400 hover:text-red-500 text-xs mx-2">
          {currentText.terms}
        </Link>
        <Link to="/privacy" className="text-gray-400 hover:text-red-500 text-xs mx-2">
          {currentText.privacy}
        </Link>
        <Link to="/cookies" className="text-gray-400 hover:text-red-500 text-xs mx-2">
          {currentText.cookies}
        </Link>
      </div>
    </div>
  );
};

export default CookieConsent;